/**
 * 角色创建选项池 — 职业、性格标签、兴趣等
 */

export const JOB_OPTIONS = [
  '程序员', '产品经理', '设计师', '教师', '医生', '律师',
  '公务员', '自由职业', '创业者', '金融从业者', '媒体人', '销售',
  '工程师', '科研人员', '厨师', '健身教练', '摄影师', '音乐人',
  '护士', '会计', '建筑师', '咖啡师', '电竞选手', '主播',
  '美发师', '宠物美容师', '占星师', '策展人', '模特', '作家',
  'AI研究员', '大学教授', '博士生', '算法工程师','明星', '文艺工作者','运动员'
];

export const PERSONALITY_TAGS = [
  '温柔', '强势', '幽默', '内向', '外向', '理性',
  '感性', '独立', '黏人', '佛系', '卷王', '社恐',
  '社牛', '文艺', '务实', '浪漫', '毒舌', '暖心',
  '高冷', '话痨', '慢热', '直率', '腹黑', '乐观',
  '悲观', '完美主义', '随性', '倔强',
];   


export const INTEREST_TAGS = [
  '旅行', '美食', '健身', '阅读', '电影', '音乐',
  '游戏', '摄影', '烹饪', '手工', '户外', '宠物',
  '二次元', '追剧', '运动', '画画', '写作', '咖啡',
  '品酒', '瑜伽', '露营', '滑雪', '潜水', '骑行',
  '桌游', '密室逃脱', '逛展', '园艺', '编程', '开源',
  '科技数码', '学术论文',
];

/** 随机名字池 */
export const RANDOM_NAMES_MALE = [
  '小明', '小杰',  '子轩', '浩然', '俊熙',
  '天佑', '小黄', '二蛋', '朝朝', '宇航', '玺玺',
  '昊昊', '傻蛋', '鹏程', '二狗',
];

export const RANDOM_NAMES_FEMALE = [
  '小红', '二丫', '丫头', '诗涵', '梦琪', '欣怡',
  '佳琪', '思颖', '雅琴', '晓彤', '紫萱', '若曦',
  '芷若', '语嫣', '静怡', '心怡',
];

// =============================================================================
// 预设角色模板
// =============================================================================

import type { CharacterInput } from '../types/character';

export interface CharacterPreset {
  label: string;
  description: string;
  input: CharacterInput;
}

export const CHARACTER_PRESETS: CharacterPreset[] = [
  {
    label: '🔬 NLP博士生',
    description: '苏大NLP方向在读博士，研究大模型和信息抽取，热衷开源',
    input: {
      name: '朱桐',
      age: 27,
      gender: 'male',
      job: '博士生',
      personality: ['理性', '卷王', '慢热'],
      interests: ['编程', '开源', '学术论文'],
      loveView: '随缘',
      independence: '高',
      asset: '基础生存',
    },
  },
  {
    label: '💻 AI算法工程师',
    description: '大厂算法岗，天天调参炼丹，周末就想躺平',
    input: {
      name: '陈厚全',
      age: 28,
      gender: 'male',
      job: '算法工程师',
      personality: ['内向', '务实', '幽默'],
      interests: ['游戏', '科技数码', '咖啡'],
      loveView: '务实',
      independence: '高',
      asset: '中资',
    },
  },
  {
    label: '🎓 高校青年教师',
    description: '刚入职的高校讲师，科研教学两头忙，温柔但有点社恐',
    input: {
      name: '林亚慧',
      age: 29,
      gender: 'female',
      job: '大学教授',
      personality: ['温柔', '社恐', '完美主义'],
      interests: ['阅读', '写作', '咖啡'],
      loveView: '浪漫',
      independence: '高',
      asset: '小资',
    },
  },
  {
    label: '🧪 AI创业者',
    description: '从实验室走出来的技术创业者，做AI应用，节奏快压力大',
    input: {
      name: '赵二狗',
      age: 30,
      gender: 'male',
      job: '创业者',
      personality: ['强势', '乐观', '直率'],
      interests: ['科技数码', '健身', '旅行'],
      loveView: '开放',
      independence: '高',
      asset: '中资',
    },
  },
  {
    label: '📊 数据科学家',
    description: '互联网公司数据团队，理性到骨子里，但私下很文艺',
    input: {
      name: '苏苹果',
      age: 26,
      gender: 'female',
      job: '算法工程师',
      personality: ['理性', '文艺', '独立'],
      interests: ['阅读', '画画', '编程'],
      loveView: '务实',
      independence: '高',
      asset: '小资',
    },
  },
  {
    label: '🎨 自由插画师',
    description: '全职自由插画师，作息混乱但内心丰富，猫奴一枚',
    input: {
      name: '沈橘子',
      age: 25,
      gender: 'female',
      job: '自由职业',
      personality: ['感性', '随性', '浪漫'],
      interests: ['画画', '宠物', '二次元'],
      loveView: '浪漫',
      independence: '中',
      asset: '基础生存',
    },
  },
];
